import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Onda",
    legalName: "Onda Studio S.r.l.",
    description: "Onda is an independent software studio in Milano designing and engineering digital products, cloud platforms and data systems for companies that refuse to stand still.",
    url: getOrigin(),
    contact: {
        email: 'hello@onda.studio',
        phone: '+39 02 8734 1120',
        phoneHref: '+390287341120',
        street: "Via Tortona 31",
        city: "20144 Milano, Italy"
    }
}
